<transfer-documents-group #certificateDocuments [blockInputs]="blockInputs" [groupTitle]="'transfer-documents.subtitle-certificate' | translate"
						  [explanationText]="'transfer-documents.text-certificate' | translate"/>
<transfer-documents-group #reportDocuments [blockInputs]="blockInputs" [groupTitle]="'transfer-documents.subtitle-reports' | translate"
						  [explanationText]="'transfer-documents.text-reports' | translate"/>
